<h1><b>{{ title || ( getLabel(path) ) }}</b></h1>
